import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common_layout" }
const _hoisted_2 = { style: {"padding-left":"32px","padding-right":"32px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "賬號", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "密碼", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "再次輸入密碼", -1)
const _hoisted_6 = { class: "center_flex_layout" }

import { reactive, onMounted, getCurrentInstance } from "vue";
import { get, post } from "../../utils/request";
import { Decrypt } from "../../utils/secret";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'editChildAccount',
  setup(__props) {

const router = useRouter();
const { proxy }: any = getCurrentInstance();

const pageTitle = reactive({ value: "" });
const childId = reactive({ value: "" });
const childAccount = reactive({ value: "" });
const childPassword = reactive({ value: "" });
const childConfirmPass = reactive({ value: "" });
const bottomButtonText = reactive({ value: "" });

onMounted(() => {
  //先解码再解密
  if (router.currentRoute.value.query.childData) {
    const encodedData = JSON.parse(
      Decrypt(decodeURIComponent(router.currentRoute.value.query.childData))
    );
    // console.log(encodedData);
    childId.value = encodedData.id;
    childAccount.value = encodedData.username;
    childPassword.value = encodedData.password;
    childConfirmPass.value = encodedData.password;
    bottomButtonText.value = "修改";
    pageTitle.value = "修改子賬號";
  } else {
    // console.log('没东西');
    bottomButtonText.value = "添加";
    pageTitle.value = "添加子賬號";
  }
});

const editAddChild = () => {
  if (!childAccount.value) {
    proxy.$toast("請輸入賬號");
    return;
  }

  if (!childPassword.value) {
    proxy.$toast("請輸入密碼");
    return;
  }

  if (!childConfirmPass.value) {
    proxy.$toast("請再次輸入密碼");
    return;
  }

    if (childPassword.value !== childConfirmPass.value) {
        proxy.$toast('兩次密碼不一致');
        return;
    }

    let isCorrect = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;  // 正则判断密码至少8位，且是数字，字母两种组合

    if (!isCorrect.test(childPassword.value)) {
        proxy.$toast('密碼要求至少8位字符，最大20位字符，並且需要字母數字兩種組合');
        return;
    }

  let childParams = {
    id: childId.value,
    username: childAccount.value,
    password: childPassword.value,
  };

  post("/manager/sub/account", childParams, null)
    .then((res) => {
      // console.log(JSON.stringify(res));
      if (res.code === 1) {
        if (childId.value) {
          proxy.$toast("修改成功");
        } else {
          proxy.$toast("添加成功");
        }
        router.go(-1);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader, {
      title: pageTitle.value
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: childAccount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((childAccount.value) = $event)),
        placeholder: "請輸入賬號"
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: childPassword.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((childPassword.value) = $event)),
        placeholder: "請輸入密碼"
      }, null, 8, ["modelValue"]),
      _hoisted_5,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: childConfirmPass.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((childConfirmPass.value) = $event)),
        placeholder: "請再次輸入密碼"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"134px","margin-top":"140px"},
          size: "large",
          onClick: editAddChild
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bottomButtonText.value), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})